import type { ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './GhostWeightLabel.module.css';

export type GhostWeightLabelProps = {
  children: ReactNode;
  active?: boolean;
  className?: string;
};

/** Reserves semibold width so toggling 500→600 does not shift siblings (static fonts). */
export function GhostWeightLabel({ children, active = false, className }: GhostWeightLabelProps) {
  if (typeof children !== 'string' && typeof children !== 'number') {
    return <>{children}</>;
  }
  const text = typeof children === 'number' ? String(children) : children;
  return (
    <span className={cx(styles.root, className)}>
      <span className={styles.ghost} aria-hidden>
        {text}
      </span>
      <span className={active ? styles.visibleActive : styles.visible}>{text}</span>
    </span>
  );
}

GhostWeightLabel.displayName = 'GhostWeightLabel';
